module.exports = __webpack_public_path__ + "static/mechatronics-a5d0c47707fc2ee7dc2655b4dd663cf8.jpg";